import React, { useState, useEffect, useRef } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  TextField,
  Paper,
  Box,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import TTareas from '../../GestionDeTareas/TTareas.js';
import { obtenerCobranzasAsignadas } from '../../../actions/CobranzasAction';

const PanelCobranzasAsignadas = (props) => {
  const mounted = useRef(true);
  const [{ sesionUsuario }] = useStateValue();
  const [Datar, setDatar] = useState([]);
  const [term, setTerm] = useState('');
  const [datosCargados, setDatosCargados] = useState(false);
  useEffect(() => {
    if (mounted.current) {
      obtenerCobranzasAsignadas(sesionUsuario.usuario.id).then((response) => {
        const Data = response.data;
        setDatar(Data);
        setDatosCargados(true);
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [sesionUsuario]);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <AssignmentIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative' }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
          >
            <AssignmentIcon sx={{ fontSize: 40 }} />
            Cobranzas Asignadas
          </Typography>
          <Typography variant="body1" color="rgba(255,255,255,0.9)">
            {sesionUsuario.usuario.nombrecompleto}
          </Typography>
        </Box>
      </Paper>

      {/* Search Bar */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar cobranzas..."
          name="term"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Content */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TTareas
            rows={Datar}
            termc={term}
            history={props.history}
            id={'Propietario'}
            cobrador={true}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="h6" color="text.secondary">
              Cargando cobranzas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};
export default PanelCobranzasAsignadas;
